/**
 * systemNoticeServiceModule 系统公告服务
 * author: Qian.qianchen 2019-06-28
 */
'use strict';
angular.module('systemNoticeServiceModule', ['uploadFilesModule','tenantTransferModule'])
    .factory('systemNoticeService', ["$modal", "$q", function($modal, $q) {
        return {
            /**
             * [uploadFiles description]上传文件
             * @return {[type]} [description]
             */
            uploadFiles:function(){
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/sysManageMent/systemNotice/services/uploadFiles/uploadFiles_tpl.html",
                    windowClass: 'upload_files_container',
                    backdrop: false,
                    controller: "uploadFilesCtrl",
                    resolve: {

                    }
                });
                //关闭弹窗
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancel");
                });
                return defer.promise;
            },
            /**
             * [tenantTransfer description] 选择租户
             * @param  {Function} callback      [description] 成功后的回调
             * @param  {[type]}   selectedTenat [description] 选中的租户
             * @return {[type]}                 [description]
             */
            tenantTransfer: function(callback, selectedTenat) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/sysManageMent/systemNotice/services/tenantTransfer/tenantTransfer_tpl.html",
                    windowClass: 'tenant_transfer_container',
                    backdrop: false,
                    controller: "tenantTransferCtrl",
                    resolve: {
                        selectedTenat: function() {
                            return selectedTenat;
                        },
                    }
                });
                //关闭弹窗
                modalInstance.result.then(function(result) {
                    callback(result);
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancel");
                });
                return defer.promise;
            },
        }
    }]);